function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 0C2.23884 0 0 2.23884 0 5C0 7.76116 2.23884 10 5 10C7.76116 10 10 7.76116 10 5C10 2.23884 7.76116 0 5 0ZM5 9.15179C2.70759 9.15179 0.848214 7.29241 0.848214 5C0.848214 2.70759 2.70759 0.848214 5 0.848214C7.29241 0.848214 9.15179 2.70759 9.15179 5C9.15179 7.29241 7.29241 9.15179 5 9.15179Z",
  fill: "#777777"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.9498 6.4129L5.35828 5.26223V2.49995C5.35828 2.45085 5.31811 2.41067 5.269 2.41067H4.73217C4.68306 2.41067 4.64288 2.45085 4.64288 2.49995V5.57361C4.64288 5.60263 4.65628 5.62942 4.67971 5.64616L6.5257 6.99214C6.56587 7.02116 6.62168 7.01223 6.6507 6.97317L6.96989 6.5379C6.99891 6.49661 6.98998 6.4408 6.9498 6.4129Z",
  fill: "#777777"
});

var SvgClockIcon = function SvgClockIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClockIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock-icon.a484a53d.svg";
export { ForwardRef as ReactComponent };